import {useTranslation} from "@Translation/hooks/useTranslation";
import {multiModalTranslationKey} from "@SearchResults/features/staticContent/constants/translationKeys";
import TitleAndContent from "@SearchResults/features/staticContent/components/TitleAndContent";
import TipsPerTransportType from "@SearchResults/features/staticContent/components/TipsPerTransportType";
import Translation from "@Translation/components/Translation";
import Tip from "@SearchResults/features/staticContent/features/multiModal/features/tips/components/Tip";
import OperatorsList from "@SearchResults/features/staticContent/components/OperatorsList";
import {TransportTypesType} from "@SearchResults/types/TransportTypes.type";
import getTranslationFromTransportType
    from "@SearchResults/features/staticContent/functions/getTranslationFromTransportType";

interface FerryTipsContentProps {
    departure: string,
    destination: string,
    priciestVehClass: TransportTypesType,
    operators: string[],
}

function FerryTipsContent({departure, destination, priciestVehClass, operators}: FerryTipsContentProps) {
    const priciestVehClassTranslation = getTranslationFromTransportType(priciestVehClass)

    const title = useTranslation(
        `${multiModalTranslationKey}.ferries.title`,
        {departure, destination}
    )

    const description = useTranslation(
        `${multiModalTranslationKey}.ferries.desc1`,
        {departure, destination, priciestVehClass: priciestVehClassTranslation}
    )

    const {
        title: o1Title,
        desc: o1Desc,
    } = useTranslation(`${multiModalTranslationKey}.ferries.trip_details.o1`)

    const {
        title: o2Title,
        desc: o2Desc,
    } = useTranslation(`${multiModalTranslationKey}.ferries.trip_details.o2`)

    const {
        title: o3Title,
        desc: o3Desc,
    } = useTranslation(`${multiModalTranslationKey}.ferries.trip_details.o3`)

    return (
        <>
            <TitleAndContent
                title={title}
                content={description}
            />
            <TipsPerTransportType
                subtitle={(
                    <Translation translationKey={`${multiModalTranslationKey}.ferries.trip_details.title`}/>
                )}
                options={[
                    {
                        id: "ferries-o1",
                        option: (<Tip title={o1Title} description={o1Desc}/>),
                    },
                    {
                        id: "ferries-o2",
                        option: (<Tip title={o2Title} description={o2Desc}/>),
                    },
                    {
                        id: "ferries-o3",
                        option: (<Tip title={o3Title} description={o3Desc}/>),
                    },
                ]}
            />
            <OperatorsList
                title={(
                    <Translation
                        translationKey={`${multiModalTranslationKey}.ferries.operators_list.title`}
                        translationVariables={{departure, destination}}
                    />

                )}
                operators={operators}
            />
        </>
    )
}

export default FerryTipsContent